module.exports = __webpack_public_path__ + "app-static/img/06.20aa1d2e.jpg";